export const calculatePaymentDatesFromDocuments = (
  documents: any,
  creditDetails: any,
) => {
  const schedule: any[] = [];
  for (let i = 0; i < documents.length; i++) {
    schedule.push({
      month: i,
      date: new Date(documents[i].paymentDate),
      diffDays: documents[i].diffDays,
      amount: documents[i].amount,
      interest: documents[i].interest,
      principal: documents[i].principal,
      balance: documents[i].balance,
      operationCost: documents[i].operationCost,
      otherExpenses: documents[i].otherExpenses,
      totalAmortization: documents[i].totalAmortization,
    });
  }
  return schedule;
};
